import { useQuery } from "@tanstack/react-query"

import { bffApi } from "@/queries/apiClient"
import formatStartDate from "@/queries/helpers/formatStartDate"
import queryKeys from "@/queries/queryKeys"

import { CardPrice } from "../models"

interface UseCardPriceOptions {
  productId: string
  arrivalDate: Date
  resortId: number
}

const useCardPriceQuery = (options: UseCardPriceOptions) => {
  const { productId, arrivalDate, resortId } = options
  const formattedDate = formatStartDate(arrivalDate)

  return useQuery<CardPrice>({
    queryKey: queryKeys.cardPrice(productId, formattedDate, resortId),
    queryFn: async () => {
      const res = await bffApi.get<CardPrice>("/card-price", {
        params: {
          productId,
          arrivalDate: formattedDate,
          resortId,
        },
      })
      return res.data
    },
    staleTime: Infinity,
    gcTime: Infinity,
  })
}

export default useCardPriceQuery
